import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import {
  useRoute
} from 'vue-router'
import DocumentViewer from '../components/DocumentViewer.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'DetailReport',
  setup(__props) {

const route = useRoute()
console.log('routt', route)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(DocumentViewer, {
    typeReport: (_unref(route).params.typeReport as string)
  }, null, 8, ["typeReport"]))
}
}

})